import React, { Component } from 'react';
import { Modal, Col, Row, Panel, Table } from 'react-bootstrap';
import Confirm from 'react-confirm-bootstrap';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';
import isBoolean from 'lodash/isBoolean';
import isNull from 'lodash/isNull';
import isNumber from 'lodash/isNumber';
import { humanize } from '../../../utils/helpers/text_formatters';
import { ContentHolder } from '../../common';
import { AdminApi } from '../../../api';
import { numberFormat } from '../../../utils/helpers/number_formatter';
import { dateFormat } from '../../../utils/helpers/date';
import { convertMillsToDollars, currencyFormat } from '../../../utils/helpers/currency';
import { currencyFields } from '../../../utils/constants';

class Show extends Component {

  getDefaultField(attribute, data, i) {
    let output = null;
    const { resourceName } = this.props;

    if (this.isDateAttribute(attribute)) {
      output = data ? dateFormat(new Date(data)) : data;
    } else if (!this.isDateAttribute(attribute) && (currencyFields || []).includes(attribute)) {
      output = currencyFormat(convertMillsToDollars(data));
    } else if (!this.isDateAttribute(attribute) && isNumber(data)) {
      output = numberFormat(data);
    } else if (isBoolean(data)) {
      output = data.toString();
    } else if (isPlainObject(data) || isNull(data)) {
      output = JSON.stringify(data).length > 140 ? <pre><code>{JSON.stringify(data)}</code></pre> : JSON.stringify(data);
    } else if (Array.isArray(data)) {
      output = data.map((v) => v.toString()).join(', ');
    } else {
      output = data;
    }

    return (
      <Panel key={`${resourceName}-show-${i}`}>
        <Panel.Heading>
          <Panel.Title componentClass="h5">
            {humanize(attribute).toUpperCase()}
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          {output}
        </Panel.Body>
      </Panel>
    );
  }

  getObjectField(attribute, data, i) {
    const { resourceName } = this.props;

    return (
      <Panel key={`${resourceName}-show-${i}`}>
        <Panel.Heading>
          <Panel.Title componentClass="h5">
            {humanize(attribute).toUpperCase()}
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <Table striped>
            <thead>
              <tr>
                {Object.keys(data[0]).map((k, index) => (<th key={index}>{humanize(k)}</th>))}
              </tr>
            </thead>
            <tbody>
              {data.map((v, index) => (
                <tr key={index}>
                  <td>{v.name}</td>
                  <td>{v.start_date ? dateFormat(new Date(v.start_date)) : v.start_date}</td>
                  <td>{v.end_date ? dateFormat(new Date(v.end_date)) : v.end_date}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Panel.Body>
      </Panel >
    );
  }

  isDateAttribute(attribute) {
    switch (attribute) {
      case 'started_at':
      case 'ended_at':
      case 'last_modified':
      case 'created_at':
      case 'updated_at':
      case 'deleted_at':
      case 'current_sign_in_at':
      case 'last_sign_in_at':
        return true;
      default:
        return false;
    }
  }

  fetchResource(params = {}) {
    const { dispatch } = this.props;
    dispatch(AdminApi.actions.websiteStats.get(params));
  }

  handleEdit() {
    const { handleHide, resourceData, onEdit } = this.props;
    handleHide();
    onEdit(resourceData.uuid, resourceData);
  }

  handleDelete() {
    const { handleHide, resourceData, onDelete } = this.props;
    onDelete(resourceData.uuid, () => {
      handleHide();
    });
  }

  shouldRenderDelete(resourceName, resourceData) {
    switch (resourceName) {
      case 'campaign':
      case 'advertiser':
      case 'publisher':
      case 'statement':
        return false;
      default:
        return (resourceData.deleted_at === undefined || resourceData.deleted_at === null);
    }
  }

  renderFields() {
    const { showColumns, resourceData } = this.props;
    return (
      <Row>
        <Col xs={12}>
          {
            showColumns.map((column, i) => {
              if (Array.isArray(resourceData[column]) && resourceData[column].length > 0 && typeof resourceData[column][0] === 'object') {
                return this.getObjectField(column, resourceData[column], i);
              }

              return this.getDefaultField(column, resourceData[column], i);
            })
          }
        </Col>
      </Row>
    );
  }

  render() {
    const {
      show,
      handleHide,
      heading,
      resourceData,
      resourceName,
      showButtons,
      isLoading
    } = this.props;
    const divStyle = { 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }
    return (
      <Modal show={show} enforceFocus={false} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={divStyle}>
          <ContentHolder loading={isLoading}>
            {this.renderFields()}
          </ContentHolder>
        </Modal.Body>

        <Modal.Footer>

          <Button onClick={handleHide}>Close</Button>
          {showButtons && this.shouldRenderDelete(resourceName, resourceData) ?
            <Confirm
              onConfirm={this.handleDelete.bind(this)}
              body="Are you sure you want to delete this?"
              confirmText="Confirm Delete"
              title={`Deleting ${humanize(resourceName)} ${resourceData.id}`}
            >
              <button className="btn btn-danger">
                Delete
            </button>
            </Confirm> : null
          }

          {showButtons ?
            <Button
              bsStyle='info'
              onClick={this.handleEdit.bind(this)}
            >
              Edit
          </Button> : null
          }

        </Modal.Footer>
      </Modal>
    );
  }
}

const ResourceModal = connectModal({
  name: 'AdminResourceShow'
});

const mapStateToProps = (state) => {
  const { modal: { AdminResourceShow }, admin } = state;
  const formProps = get(AdminResourceShow, 'props', {});
  let resource = formProps.resource || {};
  let isLoading = false;
  const resourceName = get(AdminResourceShow, 'props.resourceName', null);
  const showColumns = get(admin, `${resourceName}.data.meta.column_info.show_page`, []);

  return { resourceData: resource || {}, isLoading, showColumns };
};

export default connect(mapStateToProps)(ResourceModal(Show));
